import React, { PropsWithChildren } from 'react';

import { SideModalDisplay } from './side-modal-display';

interface SideModalProps {
  isOpen: boolean;
  closable?: boolean;
  showBackdrop?: boolean;
  handleClose: () => void;
}

export const SideModal = ({
  isOpen,
  closable = true,
  children,
  showBackdrop = true,
  handleClose,
}: PropsWithChildren<SideModalProps>) => {
  if (!isOpen) return null;

  return (
    <SideModalDisplay
      closable={closable}
      handleClose={handleClose}
      showBackdrop={showBackdrop}
    >
      {children}
    </SideModalDisplay>
  );
};
